import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function BacklinksIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame strokeLinejoin="round" {...props}>
      <path
        d="M24 5 7.55 14.5v19L24 43l16.45-9.5v-19z"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="2.4"
      />
      <g fill={toolIconPrimary}>
        <circle cx="24" cy="5" r="3.2" />
        <circle cx="7.55" cy="14.5" r="3.2" />
        <circle cx="7.55" cy="33.5" r="3.2" />
        <circle cx="24" cy="43" r="3.2" />
        <circle cx="40.45" cy="33.5" r="3.2" />
        <circle cx="40.45" cy="14.5" r="3.2" />
      </g>
      <path
        d="m18.811 22.217-3.898 3.897a4.93 4.93 0 0 0 6.973 6.973l3.897-3.898a7.2 7.2 0 0 1-2.995-.767l-2.783 2.784a2.27 2.27 0 0 1-3.211-3.211l2.784-2.783a7.2 7.2 0 0 1-.767-2.995Z"
        fill={toolIconSecondary}
        stroke={toolIconSecondary}
        strokeWidth=".8"
      />
      <path
        d="M32.146 15.854a3.6 3.6 0 0 1 0 5.091l-3.564 3.564a3.6 3.6 0 0 1-5.091 0 3.6 3.6 0 0 1 0-5.091l3.564-3.564a3.6 3.6 0 0 1 5.091 0Z"
        fill="none"
        stroke={toolIconSecondary}
        strokeWidth="3.46"
      />
    </ToolIconFrame>
  );
}
